import React from 'react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import { RTUData } from '../../types/RtuData';
import { LoginActivityDto } from '../../types/actionTypes';
import { formatDisplayDateTime } from '../../utils/dateTimeFormat';

interface RtuSessionCardProps {
  data: RTUData | null | undefined;
  latestLogin?: LoginActivityDto | null;
}

const RtuSessionCard: React.FC<RtuSessionCardProps> = ({ data, latestLogin }) => {
  const { t } = useTranslation();
  const snapshotLogin = data?.genericEvent?.login;
  const login = latestLogin
    ? {
        username: latestLogin.username,
        ip: latestLogin.sourceIp,
        type: latestLogin.loginType,
        utcTime: latestLogin.loginUtcTime,
      }
    : snapshotLogin;
  const hasLogin = Boolean(login?.username || login?.ip || login?.type || login?.utcTime);

  return (
    <Card title={t('rtuDetail.sections.lastAccess')} className="info-card compact-card flat-card">
      {hasLogin ? (
        <div className="scrollable-card-content">
          <table className="kv-table">
            <tbody>
              <tr>
                <td>{t('rtuDetail.lastAccess.username')}</td>
                <td>{login?.username || '—'}</td>
              </tr>
              <tr>
                <td>{t('rtuDetail.lastAccess.ipAddress')}</td>
                <td>{login?.ip || '—'}</td>
              </tr>
              <tr>
                <td>{t('rtuDetail.lastAccess.type')}</td>
                <td>{login?.type || '—'}</td>
              </tr>
              <tr>
                <td>{t('rtuDetail.lastAccess.recordedAt')}</td>
                <td>{formatDisplayDateTime(login?.utcTime)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="rtu-last-access-empty">No login activity recorded</div>
      )}
    </Card>
  );
};

export default RtuSessionCard;
